export default function () {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');

  $(`#${widgetName}`).videoWidget({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    maxVideos: 1,
    autoPlayVideo: false,
    loopVideo: false,
    showControls: true,

    videoWidgetLoaded: function (data) {
      const videoCount = data.Slides.length > 0;

      if (!videoCount) {
        $('.tier-five').addClass('no-video-loaded');
        $('#videoSection').remove();
      }
    },
  });
}
